
    import { Mapper } from "../../../../base/utils/mapper";
    import { InvoiceResponseModel } from "../../../../domain/models/configuration/invoice-response.model";
    import { InvoiceResponseEntity } from "../entities/invoice-response.entity";

    export class InvoiceImplementationRepositoryMapper extends Mapper<InvoiceResponseEntity, InvoiceResponseModel>{
        mapFrom(param:  InvoiceResponseEntity):  InvoiceResponseModel { 
            return {
                data:param.data,
                isSuccess:param.isSuccess,
                message:param.message,
                errors:param.errors
            }; 
        }
        mapTo(param:  InvoiceResponseModel):  InvoiceResponseEntity {
            return {
                data:param.data,
                isSuccess:param.isSuccess,
                message:param.message,
                errors:param.errors 
            };
        }
    }